import { useEffect } from 'react'
import Snackbar from '@mui/material/Snackbar'
import { Info, CheckCircleOutline, Warning, Error } from '@mui/icons-material'

import { Alert } from '@mui/material'
import { colors } from '@/theme/colors.theme'

export const variantSnackbarIcon = {
  success: CheckCircleOutline,
  warning: Warning,
  error: Error,
  info: Info,
}

export type SnackbarProps = {
  message: string
  open: boolean
  handleClose: () => void
  variant: keyof typeof variantSnackbarIcon
  automaticClose?: boolean
}

const SnackbarWrapper = ({
  message,
  open,
  handleClose,
  variant,
  automaticClose,
}: SnackbarProps) => {
  const onClose = (_event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return
    }

    handleClose()
  }

  useEffect(() => {
    return () => {
      handleClose()
    }
  }, []) // eslint-disable-line

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      open={open}
      autoHideDuration={automaticClose ? 7000 : null}
      onClose={automaticClose ? onClose : () => {}}
    >
      <Alert
        onClose={onClose}
        severity={variant}
        variant="filled"
        sx={{
          flexWrap: 'nowrap',
          color: colors.white,
          fontWeight: 600,
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  )
}

export default SnackbarWrapper
